import { pipe, filter, sortBy, forEach, prop, propEq, T } from "ramda";

export default class Section {
  constructor(params) {
    this.destroy = this.destroy.bind(this);
    this.getSelectedSeats = this.getSelectedSeats.bind(this);
    this.setSelectedSeats = this.setSelectedSeats.bind(this);
    this.selectSeat = this.selectSeat.bind(this);
    this.deselectSeat = this.deselectSeat.bind(this);
    this.selectSeats = this.selectSeats.bind(this);
    this.deselectSeats = this.deselectSeats.bind(this);
    this.setSeatSelected = this.setSeatSelected.bind(this);
    this.seatsData = params.data;
    this.plugins = params.plugins || [];
    this.seats = {};
    this.selectionFilter = params.selectionFilter || T;
    this.standSeatsWidth = 0;
    this.standSeatsHeight = 0;
    this.seatsWidth = 0;
    this.seatsHeight = 0;
    this.$arena = $(params.container || params.containerEl);
    this.SEAT_WIDTH = Number(
      getComputedStyle(this.$arena[0])
        .getPropertyValue("--seat-width")
        .replace("px", "")
    );
    this.SEAT_HEIGHT = Number(
      getComputedStyle(this.$arena[0])
        .getPropertyValue("--seat-height")
        .replace("px", "")
    );

    this.$ = this.$arena;
    this.$seats = $("<div class='seats-container' />").appendTo(this.$);
    this.wrapper = params.wrapper || window;
    this.$.data("instance", this);
    pipe(
      sortBy(propEq("priority")),
      forEach((plugin) => plugin.run.call(plugin, this))
    )(this.plugins);
    this.$scene = this.$arena.prev(".scene");
    if (this.$scene.length === 0) {
      this.$scene = this.$arena.next(".scene");
    }

    // Start rendering
    this.draw();
  }

  destroy() {
    pipe(
      filter(prop("destroy")),
      forEach((plugin) => {
        try {
          plugin.destroy.call(plugin, this);
        } catch (e) {
          console.log("destroy error", plugin, e);
        }
      })
    )(this.plugins);
    return this.$arena.off();
  }

  /*
   */
  draw() {
    let sectionVersion = getComputedStyle(this.$arena[0])
      .getPropertyValue("--section-version")
      ?.trim();

    this.$arena[0].setAttribute("data-section-version", sectionVersion ?? 1);

    this.$arena.addClass("arena-large");
    if ($("html").hasClass("touch")) {
      this.$arena.addClass("preview");
    }

    this.$arena.trigger("seats:rendering");

    this.$arena.css({
      width: `${this.seatsWidth + this.standSeatsWidth}px`,
      height: `${this.seatsHeight + this.standSeatsHeight}px`,
      padding: `${this.SEAT_HEIGHT}px ${this.SEAT_WIDTH}px`,
    });

    this.$seats.css({
      width: `${this.seatsWidth + this.standSeatsWidth}px`,
      height: `${this.seatsHeight + this.standSeatsHeight}px`,
    });

    this.$scene.css({
      left: `${this.SEAT_WIDTH}px`,
      width: `${this.seatsWidth + this.standSeatsWidth}px`,
    });

    // let everybody know that seats already prepared
    this.$arena.trigger("seats:rendered");
    return this;
  }

  getSelectedSeats() {
    return Object.keys(this.seats)
      .filter((x) => this.seats[x].selected)
      .map((x) => this.seats[x]);
  }

  setSelectedSeats(ids) {
    if (!ids) return [];
    Object.keys(this.seats)
      .filter((x) => this.seats[x].selected)
      .forEach((x) => this.setSeatSelected(this.seats[x], false));

    return ids.forEach((id) => this.setSeatSelected(this.seats[id], true));
  }

  /*
  Methods for changing seats state
  */
  selectSeat(row, coll) {
    const seat = this.getSeat(row, coll);
    if (!seat) {
      return;
    }
    if (seat.selected === true) {
      return;
    }
    this.setSeatSelected(seat, true);

    setTimeout(() => this.$.trigger("seat:select", [[seat]]), 0);
    setTimeout(
      () => this.$.trigger("seat:selectionChanged", [this.getSelectedSeats()]),
      0
    );
  }

  deselectSeat(row, coll) {
    const seat = this.getSeat(row, coll);
    if (!seat) {
      return;
    }
    if (seat.selected === false) {
      return;
    }
    this.setSeatSelected(seat, false);

    setTimeout(() => this.$.trigger("seat:deselect", [[seat]]), 0);
    setTimeout(
      () => this.$.trigger("seat:selectionChanged", [this.getSelectedSeats()]),
      0
    );
  }

  selectSeats(seats) {
    seats.forEach((seat) => this.setSeatSelected(seat, true));

    setTimeout(() => this.$.trigger("seat:select", [seats]), 0);
    return setTimeout(
      () => this.$.trigger("seat:selectionChanged", [this.getSelectedSeats()]),
      0
    );
  }

  deselectSeats(seats) {
    seats.forEach((seat) => this.setSeatSelected(seat, false));

    setTimeout(() => this.$.trigger("seat:deselect", [seats]), 0);
    return setTimeout(
      () => this.$.trigger("seat:selectionChanged", [this.getSelectedSeats()]),
      0
    );
  }

  /*
  Some useful helpers
  */
  setSeatSelected(seat, bool) {
    if (!seat) return false;
    seat.selected = bool;
    return seat.el.attr("data-selected", bool);
  }

  setSeatStatus(seat, status) {
    seat.status = status;
    return seat.el.attr("data-status", status);
  }

  getSeat(row, coll) {
    return this.seats[`${row}-${coll}`];
  }
}

window.Section = Section;
